function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 20,
  r: 3,
  fill: "#5D5D5D"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 2,
  fill: "#5D5D5D"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 36,
  r: 3,
  fill: "#5D5D5D"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 51,
  r: 2,
  fill: "#5D5D5D"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 4,
  fill: "#5D5D5D"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 5,
  r: 3,
  fill: "#5D5D5D"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 36,
  r: 4,
  fill: "#5D5D5D"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 51,
  r: 3,
  fill: "#5D5D5D"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 20,
  r: 4,
  fill: "#5D5D5D"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 5,
  r: 3,
  fill: "#5D5D5D"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 20,
  r: 3,
  fill: "#5D5D5D"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 5,
  r: 2,
  fill: "#5D5D5D"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 4,
  fill: "#5D5D5D"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 36,
  r: 3,
  fill: "#5D5D5D"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 51,
  r: 3,
  fill: "#5D5D5D"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 51,
  r: 2,
  fill: "#5D5D5D"
});

var SvgBmi = function SvgBmi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BMI.dfccafee.svg";
export { ForwardRef as ReactComponent };